import { Tooltip } from "@material-ui/core";
import React from 'react';
import { formatDate, Timestamp, toMoment } from "../../../../../services/time";

export const DateWithTooltip = ({
  date,
  textBefore,
  textAfter
}: {
  date: Timestamp;
  textBefore?: string;
  textAfter?: string;
}) => {
  const dateSimple = formatDate(toMoment(date), 'MMMM Do');
  const dateComplete = formatDate(toMoment(date), 'dddd, MMMM Do YYYY, h:mm a');
  return (
    <Tooltip title={dateComplete}>
      <span>
        {textBefore && textBefore + ' '}
        {dateSimple}
        {textAfter && ' ' + textAfter}
      </span>
    </Tooltip>
  );
};